export default "__VITE_ASSET__cBvlIXts__ 600w";